import React from "react"

const PageHeading = ({ children }) => (
  <h1 className="mb-10 inline-block border-b-2 text-2xl font-medium">
    {children}
  </h1>
)

export default PageHeading
